export const EDIT_COMPONENT_TITLE_MAX_WIDTH = 166;
export const VIEW_COMPONENT_TITLE_MAX_WIDTH = 204;
export const LAST_OWNER = 'last_owner';
